// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__ujYo9","navheading":"Navbar_navheading__FB2s0"};